import version from "../utils/version";

const PRODUCTION = process.env.PRODUCTION === "true";
const ENVIRONMENT = process.env.ENVIRONMENT;
const WhatsappQRAddress = {
    production: "https://api.supsis.live/api/whatsapp/qr",
    stage: "https://beta-api.supsis.live/api/whatsapp/qr",
    development: "http://tablet-api-local.supsis.live/api/whatsapp/qr",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp/qr",
};
const WhatsappV2QRAddress = {
    production: "https://api.supsis.live/api/whatsapp-v2/qr",
    stage: "https://beta-api.supsis.live/api/whatsapp-v2/qr",
    development: "http://tablet-api-local.supsis.live/api/whatsapp-v2/qr",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp-v2/qr",
};
const WhatsappSnapshotAddress = {
    production: "https://api.supsis.live/api/whatsapp/ss",
    stage: "https://beta-api.supsis.live/api/whatsapp/ss",
    development: "http://tablet-api-local.supsis.live/api/whatsapp/ss",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp/ss",
};
const WhatsappAvatarAddress = {
    production: "https://api.supsis.live/api/whatsapp/wp-avatar",
    stage: "https://beta-api.supsis.live/api/whatsapp/wp-avatar",
    development: "http://tablet-api-local.supsis.live/api/whatsapp/wp-avatar",
    dev: "http://tablet-api-local.supsis.live/api/whatsapp/wp-avatar",
};

const TabletHostAddress = {
    production: "https://api.supsis.live/api/hosts",
    stage: "https://beta-api.supsis.live/api/hosts",
    development: "http://tablet-api-local.supsis.live/api/hosts",
    dev: "http://tablet-api-local.supsis.live/api/hosts",
};

const EmailDomains = {
    dev: "local.email.supsis.live",
    development: "local.email.supsis.live",
    stage: "beta.email.supsis.live",
    production: "email.supsis.live",
};

const CalendarUrls = {
    dev: "https://calendar.local.supsis.live",
    development: "https://calendar.local.supsis.live",
    stage: "https://calendar-beta.supsis.live",
    production: "https://calendar.supsis.live",
};

const isStage = ENVIRONMENT === "stage";
const isDevelopment = ENVIRONMENT === "development";

const calendarOAuthUrl = {
    dev: `https://socket-local.supsis.live:30051/webhook/calendar-oauth`,
    development: `https://socket-local.supsis.live:30051/webhook/calendar-oauth`,
    stage: `https://beta-socket.supsis.live/webhook/calendar-oauth`,
    production: `https://socket.supsis.live/webhook/calendar-oauth`,
};

const youtubeOAuthUrl = {
    dev: `https://socket-local.supsis.live:30051/webhook/youtube-oauth`,
    development: `https://socket-local.supsis.live:30051/webhook/youtube-oauth`,
    stage: `https://beta-socket.supsis.live/webhook/youtube-oauth`,
    production: `https://socket.supsis.live/webhook/youtube-oauth`,
};

const googleBusinessOAuthUrl = {
    dev: `https://socket-local.supsis.live:30051/webhook/google-business-oauth`,
    development: `https://socket-local.supsis.live:30051/webhook/google-business-oauth`,
    stage: `https://beta-socket.supsis.live/webhook/google-business-oauth`,
    production: `https://socket.supsis.live/webhook/google-business-oauth`,
};

const googlePlayOAuthUrl = {
    dev: `https://socket-local.supsis.live:30051/webhook/google-play-oauth`,
    development: `https://socket-local.supsis.live:30051/webhook/google-play-oauth`,
    stage: `https://beta-socket.supsis.live/webhook/google-play-oauth`,
    production: `https://socket.supsis.live/webhook/google-play-oauth`,
};

const googleDriveOAuthUrl = {
    dev: `https://socket-local.supsis.live:30051/webhook/google-drive-oauth`,
    development: `https://socket-local.supsis.live:30051/webhook/google-drive-oauth`,
    stage: `https://beta-socket.supsis.live/webhook/google-drive-oauth`,
    production: `https://socket.supsis.live/webhook/google-drive-oauth`,
};

const SocketBaseUrl = {
    dev: "https://socket-local.supsis.live:30051",
    development: "https://socket-local.supsis.live:30051",
    stage: "https://beta-socket.supsis.live",
    production: "https://socket.supsis.live",
};

const CONFIG = {
    PRODUCTION,
    ENVIRONMENT,
    SOCKET_URL: process.env.SOCKET_URL,
    SOCKET_BASE_URL: SocketBaseUrl[ENVIRONMENT],
    IS_STAGE: isStage,
    IS_DEVELOPMENT: isDevelopment,
    VERSION: version,
    CALENDAR: {
        CLIENT_ID: "475178287199-g1rjfhqc6v56qeo357qoqdid8683pojm.apps.googleusercontent.com",
        SCOPE: [
            "https://www.googleapis.com/auth/calendar.readonly",
            "https://www.googleapis.com/auth/calendar.calendars.readonly",
            "https://www.googleapis.com/auth/calendar",
            "https://www.googleapis.com/auth/calendar.events",
        ].join(" "),
        REDIRECT_URI: calendarOAuthUrl[ENVIRONMENT],
        OAUTH2_ENDPOINT: "https://accounts.google.com/o/oauth2/v2/auth",
    },
    YOUTUBE: {
        CLIENT_ID: "475178287199-g1rjfhqc6v56qeo357qoqdid8683pojm.apps.googleusercontent.com",
        SCOPE: "https://www.googleapis.com/auth/youtube.force-ssl",
        REDIRECT_URI: youtubeOAuthUrl[ENVIRONMENT],
        OAUTH2_ENDPOINT: "https://accounts.google.com/o/oauth2/v2/auth",
    },
    GOOGLE_BUSINESS: {
        CLIENT_ID: "475178287199-g1rjfhqc6v56qeo357qoqdid8683pojm.apps.googleusercontent.com",
        SCOPE: "https://www.googleapis.com/auth/business.manage",
        REDIRECT_URI: googleBusinessOAuthUrl[ENVIRONMENT],
        OAUTH2_ENDPOINT: "https://accounts.google.com/o/oauth2/v2/auth",
    },
    GOOGLE_PLAY: {
        CLIENT_ID: "475178287199-g1rjfhqc6v56qeo357qoqdid8683pojm.apps.googleusercontent.com",
        SCOPE: "https://www.googleapis.com/auth/androidpublisher",
        REDIRECT_URI: googlePlayOAuthUrl[ENVIRONMENT],
        OAUTH2_ENDPOINT: "https://accounts.google.com/o/oauth2/v2/auth",
    },
    GOOGLE_DRIVE: {
        CLIENT_ID: "475178287199-g1rjfhqc6v56qeo357qoqdid8683pojm.apps.googleusercontent.com",
        SCOPE: "https://www.googleapis.com/auth/drive.readonly  https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive",
        REDIRECT_URI: googleDriveOAuthUrl[ENVIRONMENT],
        OAUTH2_ENDPOINT: "https://accounts.google.com/o/oauth2/v2/auth",
    },
    WEB_PUSH: {
        APP_SYNC_API_KEY: "da2-xzpo6dhcejfjhab3kpmydqmciu",
        APP_SYNC_URL: "https://ipj5j7mrcnfnrhmxgcbdv2yuiy.appsync-api.us-east-1.amazonaws.com/graphql",
        // VAPID_KEYS: VAPIDKeyStorage.getVapidKeys(),
        applicationServerKey: "BH860EdAPR_2Hwi1hc1V5Cc8tngWkjxpGOLhNR2D9jKJUFWhO2FQD5O6K10Uo_8Mu5W-WtfckH6bPju-wonJsMU",
    },
    WHATSAPP: {
        qrAddress: WhatsappQRAddress[ENVIRONMENT],
        qrAddressV2: WhatsappV2QRAddress[ENVIRONMENT],
        snapshotAddress: WhatsappSnapshotAddress[ENVIRONMENT],
        avatarAddress: WhatsappAvatarAddress[ENVIRONMENT],
        LAUNCH_STATES: {
            NOT_CREATED: "NOT_CREATED",
            DEAD: "DEAD",
            QR_CODE_GENERATING: "QR_CODE_GENERATING",
            QR_CODE_GENERATED: "QR_CODE_GENERATED",
            AUTHENTICATING: "AUTHENTICATING",
            READY: "READY",
        },
        PRICE: {
            whatsappBroadcastBasePrice: 0.25,
            marketingBasePrice: 0.0109,
            dollarDefaultPrice: 43,
        },
    },
    INSTAGRAM: {
        STATES: {
            NOT_CREATED: "NOT_CREATED",
            AUTHENTICATING: "AUTHENTICATING",
            AUTH_FAILED: "AUTH_FAILED",
            CHALLENGE_REQUIRED: "CHALLENGE_REQUIRED",
            READY: "READY",
            DEAD: "DEAD",
        },
        ENABLED: true || ENVIRONMENT !== "production",
    },
    SUPPORTED_LANGS: ["tr", "en", "ru", "de", "fr", "es", "ar", "it"],
    TEAM_CHAT: {
        enabled: true,
    },
    MULTI_WHATSAPP: {
        enabled: true,
    },
    CHATBOT_RAPOR: {
        enabled: true,
    },
    AKINON: {
        enabled: [
            "beta.supsis.live",
            // "local.supsis.live",
            "aydinli.supsis.live",
            "aydinli.beta.supsis.live",
            "uspoloassn.supsis.live",
            "cacharel.supsis.live",
            "pierrecardin.supsis.live",
        ].includes(window.location.hostname),
        enabledReal: [
            // "local.supsis.live",
            "aydinli.beta.supsis.live",
            "uspoloassn.supsis.live",
            "cacharel.supsis.live",
            "pierrecardin.supsis.live",
        ].includes(window.location.hostname),
        attributes: [
            {
                name: "BRAND",
                placeholder: "US POLO",
                value: "akinon_brand",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "User ID",
                placeholder: "7812331",
                value: "akinon_user_id",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "User Name",
                placeholder: "Ahmet Yılmaz",
                value: "akinon_user_name",
                type: "akinon",
                defaultOperator: "contain",
            },
            {
                name: "User Email",
                placeholder: "ayilmaz@gmail.com",
                value: "akinon_user_email",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Product ID",
                placeholder: "50222760-VR033",
                value: "akinon_product_id",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Order ID",
                placeholder: "0114018314",
                value: "akinon_order_id",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Order Status",
                placeholder: "Teslim Edildi",
                value: "akinon_order_status",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Order Price",
                placeholder: "499₺",
                value: "akinon_order_price",
                type: "akinon",
                defaultOperator: "greater_or_equal",
            },
            {
                name: "Order Date",
                placeholder: "11.10.2022 20:34",
                value: "akinon_order_date",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "SKU",
                placeholder: "50209245009",
                value: "akinon_sku",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Invoice URL",
                placeholder: "https://apps.aydinli...",
                value: "akinon_invoice_url",
                type: "akinon",
                defaultOperator: "contain",
            },
            {
                name: "Order Shipper Name",
                placeholder: "Aras Kargo",
                value: "akinon_shipper_name",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Track Number",
                placeholder: "123456789",
                value: "akinon_track_number",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Track URL",
                placeholder: "https://...",
                value: "akinon_track_url",
                type: "akinon",
                defaultOperator: "contain",
            },
            {
                name: "Product Size",
                placeholder: "XL",
                value: "akinon_product_size",
                type: "akinon",
                defaultOperator: "equal",
            },
            {
                name: "Product URL",
                placeholder: "https://...",
                value: "akinon_product_url",
                type: "akinon",
                defaultOperator: "contain",
            },
            {
                name: "Product Title",
                placeholder: "Kadın Çorap",
                value: "akinon_product_title",
                type: "akinon",
                defaultOperator: "contain",
            },
            {
                name: "Product Image",
                placeholder: "https://...",
                value: "akinon_product_image",
                type: "akinon",
                defaultOperator: "contain",
            },
            {
                name: "Product Stock",
                placeholder: "12",
                value: "akinon_product_stock",
                type: "akinon",
                defaultOperator: "greater_or_equal",
            },
        ],
        ORDER_STATUSES: {
            CANCEL_WAITING: "İptal Bekleniyor",
            CANCELLED: "İptal Edildi",
            PENDING: "Bekliyor",
            PAYMENT_PENDING: "Ödeme Bekleniyor",
            APPROVE_PENDING: "Onay Bekleniyor",
            APPROVED: "Onaylandı",
            PREPARING: "Hazırlanıyor",
            TRACKED: "Kargolandı",
            TRACKED_AND_ACK: "Kargolandı ve bilgilendirildi",
            NOT_DELIVERED: "Teslim Edilemedi",
            DELIVERED: "Teslim Edildi",
            REFUNDED: "İade edildi",
        },
        BRAND_TYPES: {
            US_POLO_ASSN: "US_POLO_ASSN",
            PIERRE_CARDIN: "PIERRE_CARDIN",
            CACHAREL: "CACHAREL",
        },
    },
    TSOFT: {
        ORDER_STATUSES: {
            deleted: "Silindi",
            waiting_for_approval: "Onay Bekliyor",
            approved: "Onaylandı",
            fulfilled: "Kargoya Verildi",
            cancelled: "İptal Edildi",
            delivered: "Teslim Edildi",
            on_accumulation: "Tedarik Sürecinde",
            waiting_for_payment: "Ödeme Bekliyor",
            being_prepared: "Hazırlanıyor",
            refunded: "İade Edildi",
        },
        attributes: [
            {
                name: "Order ID",
                placeholder: "1971",
                value: "tsoft_order_id",
                type: "tsoft",
                defaultOperator: "equal",
            },
            {
                name: "INVOICE URL",
                placeholder: "https://apps....",
                value: "tsoft_invoice_url",
                type: "tsoft",
                defaultOperator: "equal",
            },
            {
                name: "Order Status",
                placeholder: "Kargoya Verildi",
                value: "tsoft_order_status",
                type: "tsoft",
                defaultOperator: "equal",
            },
            {
                name: "Order Shipper Name",
                placeholder: "Aras Kargo",
                value: "tsoft_shipper_name",
                type: "tsoft",
                defaultOperator: "equal",
            },
            {
                name: "Order Date",
                placheolder: "11.10.2022 20:34",
                value: "tsoft_order_date",
                type: "tsoft",
                defaultOperator: "equal",
            },
            {
                name: "Track Number",
                placeholder: "123456789",
                value: "tsoft_track_number",
                type: "tsoft",
                defaultOperator: "equal",
            },
            {
                name: "Track URL",
                placeholder: "https://...",
                value: "tsoft_track_url",
                type: "tsoft",
                defaultOperator: "equal",
            },
        ],
    },
    IDEASOFT: {
        ORDER_STATUSES: {
            deleted: "Silindi",
            waiting_for_approval: "Onay Bekliyor",
            approved: "Onaylandı",
            fulfilled: "Kargoya Verildi",
            cancelled: "İptal Edildi",
            delivered: "Teslim Edildi",
            on_accumulation: "Tedarik Sürecinde",
            waiting_for_payment: "Ödeme Bekliyor",
            being_prepared: "Hazırlanıyor",
            refunded: "İade Edildi",
        },
        attributes: [
            {
                name: "User ID",
                placeholder: "7812331",
                value: "ideasoft_user_id",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Order ID",
                placeholder: "0114018314",
                value: "ideasoft_order_id",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Order Status",
                placeholder: "Teslim Edildi",
                value: "ideasoft_order_status",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Order Price",
                placeholder: "499₺",
                value: "ideasoft_order_price",
                type: "ideasoft",
                defaultOperator: "greater_or_equal",
            },
            {
                name: "Order Date",
                placeholder: "11.10.2022 20:34",
                value: "ideasoft_order_date",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "SKU",
                placeholder: "50209245009",
                value: "ideasoft_sku",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Invoice URL",
                placeholder: "https://apps.aydinli...",
                value: "ideasoft_invoice_url",
                type: "ideasoft",
                defaultOperator: "contain",
            },
            {
                name: "Order Shipper Name",
                placeholder: "Aras Kargo",
                value: "ideasoft_shipper_name",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Track Number",
                placeholder: "123456789",
                value: "ideasoft_track_number",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Track URL",
                placeholder: "https://...",
                value: "ideasoft_track_url",
                type: "ideasoft",
                defaultOperator: "contain",
            },
            {
                name: "Product Size",
                placeholder: "XL",
                value: "ideasoft_product_size",
                type: "ideasoft",
                defaultOperator: "equal",
            },
            {
                name: "Product URL",
                placeholder: "https://...",
                value: "ideasoft_product_url",
                type: "ideasoft",
                defaultOperator: "contain",
            },
            {
                name: "Product Title",
                placeholder: "Kadın Çorap",
                value: "ideasoft_product_title",
                type: "ideasoft",
                defaultOperator: "contain",
            },
            {
                name: "Product Image",
                placeholder: "https://...",
                value: "ideasoft_product_image",
                type: "ideasoft",
                defaultOperator: "contain",
            },
            {
                name: "Product Stock",
                placeholder: "12",
                value: "ideasoft_product_stock",
                type: "ideasoft",
                defaultOperator: "greater_or_equal",
            },
        ],
    },
    TICIMAX: {
        attributes: [
            {
                name: "Order ID",
                placeholder: "1971",
                value: "ticimax_order_id",
                type: "ticimax",
                defaultOperator: "equal",
            },
            {
                name: "Order Number",
                placeholder: "0114018314",
                value: "ticimax_order_number",
                type: "ticimax",
                defaultOperator: "equal",
            },
            {
                name: "Order Status",
                placeholder: "Kargoya Verildi",
                value: "ticimax_order_status",
                type: "ticimax",
                defaultOperator: "equal",
            },
            {
                name: "Status Code",
                placeholder: "6",
                value: "ticimax_status_code",
                type: "ticimax",
                defaultOperator: "equal",
            },
            {
                name: "Order Price",
                placeholder: "499₺",
                value: "ticimax_order_price",
                type: "ticimax",
                defaultOperator: "greater_or_equal",
            },
            // removed: Currency
            {
                name: "Order Date",
                placeholder: "11.10.2022 20:34",
                value: "ticimax_order_date",
                type: "ticimax",
                defaultOperator: "equal",
            },
            {
                // removed: Order Shipper Name
            },
            {
                name: "Tracking Number",
                placeholder: "123456789",
                value: "ticimax_track_number",
                type: "ticimax",
                defaultOperator: "equal",
            },
            {
                name: "Tracking URL",
                placeholder: "https://...",
                value: "ticimax_track_url",
                type: "ticimax",
                defaultOperator: "contain",
            },
            // removed: Invoice URL, Customer Contact, Customer Email, Customer Phone, Order Products
        ],
    },
    IKAS: {
        attributes: [
            {
                name: "Customer ID",
                placeholder: "5b6b176e-...",
                value: "ikas_customer_id",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "First Name",
                placeholder: "Ali",
                value: "ikas_customer_first_name",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Last Name",
                placeholder: "Karakaya",
                value: "ikas_customer_last_name",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Email",
                placeholder: "mail@example.com",
                value: "ikas_customer_email",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Phone",
                placeholder: "+90555...",
                value: "ikas_customer_phone",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Address",
                placeholder: "EV: Istanbul / .....",
                value: "ikas_customer_address_full",
                type: "ikas",
                defaultOperator: "contain",
            },
            {
                name: "Order ID",
                placeholder: "7c9892cd-...",
                value: "ikas_order_id",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Order Number",
                placeholder: "1002",
                value: "ikas_order_number",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Order Status",
                placeholder: "FULFILLED",
                value: "ikas_order_status",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Order Price",
                placeholder: "499₺",
                value: "ikas_order_price",
                type: "ikas",
                defaultOperator: "greater_or_equal",
            },
            {
                name: "Order Date",
                placeholder: "01.10.2024",
                value: "ikas_order_date",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Currency",
                placeholder: "₺",
                value: "ikas_currency",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Tracking Number",
                placeholder: "123456789",
                value: "ikas_tracking_number",
                type: "ikas",
                defaultOperator: "equal",
            },
            {
                name: "Tracking Link",
                placeholder: "https://...",
                value: "ikas_tracking_link",
                type: "ikas",
                defaultOperator: "contain",
            },
            {
                name: "Cargo Company",
                placeholder: "Yurtiçi Kargo",
                value: "ikas_cargo_company",
                type: "ikas",
                defaultOperator: "equal",
            },
        ],
    },
    PROBEL: {
        enabled: [
            "local.supsis.live",
            "beta.supsis.live",
            "egeumut.supsis.live",
            "medigunes.supsis.live",
            "medigunes.beta.supsis.live",
            "salihlihastanesi.beta.supsis.live",
            "salihlihastanesi.supsis.live",
        ].includes(window.location.hostname),
        enabledReal: [
            "local.supsis.live",
            "probel.beta.supsis.live",
            "egeumut.supsis.live",
            "medigunes.supsis.live",
            "medigunes.beta.supsis.live",
            "salihlihastanesi.beta.supsis.live",
            "salihlihastanesi.supsis.live",
        ].includes(window.location.hostname),
        attributes: [
            {
                name: "SUBE_KODU",
                placeholder: "11",
                value: "probel_sube_kodu",
                type: "probel",
                defaultOperator: "equal",
                defaultFilterValue: "1",
            },
            {
                name: "BRANS_KODU",
                placeholder: "17",
                value: "probel_brans_kodu",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "BRANS_ADI",
                placeholder: "Nöroloji",
                value: "probel_brans_adi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "DOKTOR_ADI",
                placeholder: "Enes Dur",
                value: "probel_doktor_adi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "DOKTOR_KODU",
                placeholder: "15321",
                value: "probel_doktor_kodu",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "POLIKLINIK_ADI",
                placeholder: "Nöroloji Polikliniği",
                value: "probel_poliklinik_adi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "POLIKLINIK_KODU",
                placeholder: "3422",
                value: "probel_poliklinik_kodu",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "RANDEVU_TARIHI",
                placeholder: "01.02.2023",
                value: "probel_randevu_tarihi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "RANDEVU_SAATI",
                placeholder: "15:00",
                value: "probel_randevu_saati",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "RANDEVU_ID",
                placeholder: "3181458",
                value: "probel_randevu_id",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "HASTA_TOKEN",
                placeholder: "8O6FJU3MLJTXBNRJ",
                value: "probel_hasta_token",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "IDENTITY_TYPE",
                placeholder: "TC Vatandaşı",
                value: "probel_kimlik_tipi",
                type: "probel",
                defaultOperator: "equal",
                defaultFilterValue: "1",
                controlType: "select",
                options: [
                    { label: "TC Vatandaşı", value: "1" },
                    { label: "Yabancı uyruklu", value: "2" },
                ],
            },
            {
                name: "IDENTITY_NUMBER",
                placeholder: "12345678901",
                value: "probel_kimlik_no",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "PATIENT_NAME",
                placeholder: "Selim",
                value: "probel_hasta_adi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "PATIENT_SURNAME",
                placeholder: "Tokgöz",
                value: "probel_hasta_soyadi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "PATIENT_GENDER",
                placeholder: "Erkek",
                value: "probel_hasta_cinsiyet",
                type: "probel",
                defaultOperator: "equal",
                defaultFilterValue: "1",
                controlType: "select",
                options: [
                    { label: "Erkek", value: "1" },
                    { label: "Kadın", value: "2" },
                ],
            },
            {
                name: "PATIENT_BIRTH_DATE",
                placeholder: "01.01.1990",
                value: "probel_hasta_dogum_tarihi",
                type: "probel",
                defaultOperator: "equal",
            },
            {
                name: "PATIENT_PHONE",
                placeholder: "905555555555",
                value: "probel_hasta_telefon",
                type: "probel",
                defaultOperator: "equal",
            },
        ],
        IDENTITY_TYPES: {
            TC: "1",
            FOREIGN: "2",
        },
        GENDER_TYPES: {
            MALE: "1",
            FEMALE: "2",
        },
    },
    B2CARGO: {
        enabled: [
            "beta.supsis.live",
            "local.supsis.live",
            "supsis.live",
            "b2cargo.supsis.live",
            "mryvz.supsis.live",
        ].includes(window.location.hostname),
        attributes: [
            {
                name: "Company Code",
                placeholder: "A123123123",
                value: "b2cargo_companyCode",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Tracking Number",
                placeholder: "23332",
                value: "b2cargo_takipNo",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Tracking Serial",
                placeholder: "TSSA",
                value: "b2cargo_takipseri",
                type: "b2cargo",
                defaultOperator: "equal",
            },

            {
                name: "Order Status",
                placeholder: "4",
                value: "b2cargo_evrakdurum",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Delivery Date",
                placeholder: "11.10.2022 20:34",
                value: "b2cargo_teslimtar",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Sender Name",
                placeholder: "Supsis AI",
                value: "b2cargo_gonderen",
                type: "b2cargo",
                defaultOperator: "contains",
            },
            {
                name: "Receiver Name",
                placeholder: "Supsis AI",
                value: "b2cargo_aliciAdi",
                type: "b2cargo",
                defaultOperator: "contains",
            },
            {
                name: "Province of Departure",
                placeholder: "İstanbul",
                value: "b2cargo_cikisIl",
                type: "b2cargo",
                defaultOperator: "contains",
            },
            {
                name: "Province of Arrival",
                placeholder: "Ankara",
                value: "b2cargo_varisIl",
                type: "b2cargo",
                defaultOperator: "contains",
            },
            {
                name: "Product Status",
                placeholder: "Teslim Edildi",
                value: "b2cargo_teslim",
                type: "b2cargo",
                defaultOperator: "contains",
            },
            {
                name: "Product Type",
                placeholder: "SOGUK",
                value: "b2cargo_urun",
                type: "b2cargo",
                defaultOperator: "contains",
            },
            {
                name: "Product ATF Date",
                placeholder: "11.10.2022 20:34",
                value: "b2cargo_atfTarih",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Product Palette",
                placeholder: "2",
                value: "b2cargo_palet",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Product Parcel",
                placeholder: "635",
                value: "b2cargo_koli",
                type: "635",
                defaultOperator: "equal",
            },
            {
                name: "Product WEIGHT",
                placeholder: "596.9",
                value: "b2cargo_koli",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Product DESI",
                placeholder: "912.82",
                value: "b2cargo_desi",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Zimmet No",
                placeholder: "0001",
                value: "b2cargo_zimmetno",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "Destination Branch",
                placeholder: "00001",
                value: "b2cargo_varissube",
                type: "b2cargo",
                defaultOperator: "equal",
            },
            {
                name: "ATF State",
                placeholder: "TESLİM EDİLDİ",
                value: "b2cargo_atfDurum",
                type: "b2cargo",
                defaultOperator: "equal",
            },
        ],
    },
    HOLIDAY_PLUS: {
        enabled: ["beta.supsis.live", "local.supsis.live", "supsis.live", "mryvz.supsis.live"].includes(
            window.location.hostname
        ),
        attributes: [
            {
                name: "Holiday+ Selected Hotel ID",
                placeholder: "1",
                value: "holiday_plus_selected_hotel_id",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room ID",
                placeholder: "5",
                value: "holiday_plus_room_id",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room Title",
                placeholder: "Standart Oda - Her Şey Dahil",
                value: "holiday_plus_room_title",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room Description",
                placeholder: "Geniş, modern çift kişilik odalarımız 5..",
                value: "holiday_plus_room_description",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room Size",
                placeholder: "22 m²",
                value: "holiday_plus_room_size",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room Price Offer",
                placeholder: "6%",
                value: "holiday_plus_room_price_offer",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room Price",
                placeholder: "100₺",
                value: "holiday_plus_room_price",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Room Discount Price",
                placeholder: "95₺",
                value: "holiday_plus_room_discount_price",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Check In",
                placeholder: "2024/10/05",
                value: "holiday_plus_checkin",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Check Out",
                placeholder: "2024/10/05",
                value: "holiday_plus_checkout",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Child Count",
                placeholder: "2",
                value: "holiday_plus_child_count",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Adult Count",
                placeholder: "2",
                value: "holiday_plus_adult_count",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
            {
                name: "Holiday+ Child Ages",
                placeholder: "5,10",
                value: "holiday_plus_child_dates",
                type: "holiday_plus",
                defaultOperator: "equal",
            },
        ],
    },
    TRENDYOL: {
        enabled: true,
        attributes: [
            {
                name: "Trendyol Ürün Sorusu",
                placeholder: "Kargo ücretsizmi?",
                value: "trendyol_question",
                type: "trendyol",
                defaultOperator: "equal",
            },

            {
                name: "Trendyol Ürün Soru ID",
                placeholder: "123423",
                value: "trendyol_question_id",
                type: "trendyol",
                defaultOperator: "equal",
            },
            {
                name: "Trendyol Ürün ID",
                placeholder: "123423",
                value: "trendyol_product_id",
                type: "trendyol",
                defaultOperator: "equal",
            },
            {
                name: "Trendyol Ürün Modeli",
                placeholder: "{}",
                value: "trendyol_product",
                type: "trendyol",
                defaultOperator: "equal",
            },
        ],
    },
    PRICING: {
        WHATSAPP: {
            BASIC: {
                tl: {
                    price: 250,
                },
                usd: {
                    price: 15,
                },
            },
            PLUS: {
                tl: {
                    price: 1000,
                },
                usd: {
                    price: 70,
                },
            },
        },
        INSTAGRAM: {
            BASIC: {
                tl: {
                    price: 350,
                },
                usd: {
                    price: 15,
                },
            },
            PLUS: {
                tl: {
                    price: 1000,
                },
                usd: {
                    price: 70,
                },
            },
        },
    },
    CHATBOT: {
        // GPT3_ENABLED: ["local.supsis.live", "supsis.live", "beta.supsis.live"].includes(window.location.hostname),
        GPT3_ENABLED: true,
    },
    TWITTER: {
        CLIENT_ID: "YktEdTNyMlZCOFpqUnpZU3lPRGU6MTpjaQ",
        CLIENT_SECRET: "tSLuQIgRNfRXdMJBHSMMeSCMLHK6UK1oQfe5XvMwE58yaPpgJf",
    },
    EMAIL_DOMAIN: EmailDomains[ENVIRONMENT],
    CALENDAR_URL: CalendarUrls[ENVIRONMENT],
    // EMAIL_SERVICE_ENABLED:
    //     ["local.supsis.live", "supsis.live", "beta.supsis.live", "gpkompozit.supsis.live"].includes(
    //         window.location.hostname
    //     ) || IS_STAGE_ENVIRONMENT,
    EMAIL_SERVICE_ENABLED: true,
    CALENDAR_SERVICE_ENABLED: ["local.supsis.live", "supsis.live", "beta.supsis.live"].includes(
        window.location.hostname
    ),
    WHATSAPP_V2: true,
    MAX_FILE_UPLOAD_SIZE: 50,
    FEATURES: {
        HEYSUPSIS_ENABLED: true,
    },
    ACTIVITY: {
        enabled: true,
    },

    TABLET_HOST_ADDRESS: TabletHostAddress,
    AUTOMATION_ENABLED: true,
    FORM_SERVICE_ENABLED: true,
};
export default CONFIG;
